import { Opt } from '@caudena/core/ui-kit'

export const UIKIT_LANG_NAMESPACE = 'uikit'
export const CORE_LANG_NAMESPACE = 'core'

export const getLanguageNamespaces = (namespaces: string[]) => [
  ...namespaces,
  UIKIT_LANG_NAMESPACE,
  CORE_LANG_NAMESPACE,
]

export const getLanguageOptions = <T extends object>(languages: T) =>
  Object.entries(languages).map(([key, value]) => ({
    value: key,
    label: value,
    selected: false,
  })) as Array<Opt<keyof T>>
